import React, { useState } from "react";
import "./Header.scss";
import Timer from "./timer";
// import { PUZZLES } from "./PUZZLES";
import { motion } from "framer-motion";
import Modal from "react-responsive-modal";
import { PuzzleList } from "./PuzzleList";

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  let totalMoves = null;
  const currentPuzzle = props.PUZZLES[props.currentPuzzle];
  if (currentPuzzle) {
    totalMoves = currentPuzzle.moves;
  }
  return (
    <>
      <div className="component-header">
        <div className="left-header cursor-pointer flex items-center">
          <img
            src={process.env.PUBLIC_URL + "gameIcon.svg"}
            alt="FlowBerry Logo"
          />
          <div style={{ paddingLeft: "2px" }} className="header-title">
            Free<span className="text-white">Berry</span>
          </div>
        </div>
        <div className="center-header">
          {/* <div className="right-header">
          {totalMoves ? (
            <p className="timer v-bold text-white">
              {`${props.moves.length || 0}/${totalMoves || ""}`}
            </p>
          ) : (
            ""
          )}
        </div> */}
          <div className="right-header">
            <div className="timer v-bold text-white">
              <Timer
                gameMode={props.gameMode}
                timer={props.timer}
                PUZZLES={props.PUZZLES}
                selectPuzzle={props.selectPuzzle}
                currentPuzzle={props.currentPuzzle}
                resetTimer={props.resetTimer}
                gotoNextLevel={props.gotoNextLevel}
                gameOverSound={props.gameOverSound}
              />
            </div>
          </div>
          <div className="right-header">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="control-btn"
              onClick={() => setIsOpen(true)}
            >
              <img
                className="cursor-pointer menu-img"
                src={require("./static/menu.svg")}
                alt="FreeBerry Menu"
              />
            </motion.button>
          </div>
        </div>
      </div>
      <Modal
        classNames={{ overlay: "header-modal-component-overlay", modal: "header-modal-component-modal" }}
        open={isOpen}
        center
        onClose={() => setIsOpen(false)}
      >
        <PuzzleList
          PUZZLES={props.PUZZLES}
          gameMode={props.gameMode}
          setGameMode={props.setGameMode}
          selectPuzzle={(val) => {
            props.selectPuzzle(val);
            setIsOpen(false);
          }}
        />
      </Modal>
    </>
  );
};

export default Header;
